import React, { useState, useEffect } from 'react';
import { BentoCard } from "components/uiElements/UIComponents/bento-grid/bento-grid";
import { PSpinner } from '@porsche-design-system/components-react';
import './TourList.css';
import useGetUserAgent from 'mainApp/assets/utils/hooks/useGetUserAgent';
import { GridContainer, scrollToTop, SkeletonTourListPreload } from 'mainApp/assets/visual/styles/globalStyles/globalJsxStyles';

function TourList({ onExit }) {

    const [tours, setTours] = useState([]);
    const [loading, setLoading] = useState(true);
    const deviceType = useGetUserAgent();
    const isPhone = deviceType !== "PC";

    // Hotel Mockup Data
    const rooms = [
        // {
        //     "tourUUID": "93bba254-a5f8-404f-a6f9-1af25a2394bf",
        //     "name": "Room 1",
        //     "description": "The best way to get in touch with Madrid!",
        //     "priceMin": "79.00",
        //     "priceMax": null,
        //     "duration": 60,
        //     "cover": "9cb14acf-1c72-43f2-901d-cedc42ee272d",
        //     "createdBy": "0806f694-cf85-4cfc-a9cd-1859552b7fe8",
        //     "created_at": "2024-07-25T12:39:37.000000Z",
        //     "updated_at": "2024-10-09T13:46:23.000000Z",
        //     "stripe_price_id": "price_1Q80DaAOsdg7Yseia4fX3jlg",
        //     "stripe_product_id": "prod_QcYIY5OvPoDw6T",
        //     "position": null,
        //     "cover_image_uri": "https://www.thestablegame.com/images/44575ed1-0847-4191-9665-df22c876a2fb.webp",
        //     "cover_image": {
        //         "imageUUID": "9cb14acf-1c72-43f2-901d-cedc42ee272d",
        //         "uri": "https://www.thestablegame.com/images/44575ed1-0847-4191-9665-df22c876a2fb.webp",
        //         "created_at": "2024-10-09T12:43:43.000000Z",
        //         "updated_at": "2024-10-09T12:43:43.000000Z",
        //         "locationUUID": null
        //     }
        // },
        // {
        //     "tourUUID": "16ea4962-d0e4-4de7-80f9-57b5fd28fbcf",
        //     "name": "Room 2",
        //     "description": "Experience the breathtaking and most complete tour of Madrid.",
        //     "priceMin": "209.00",
        //     "priceMax": null,
        //     "duration": 180,
        //     "cover": "0adb6c14-6797-43d6-91a0-9e431bd8747c",
        //     "createdBy": "55f824a7-3f94-4262-b2c9-dea9691a6a0d",
        //     "created_at": "2024-07-25T12:39:37.000000Z",
        //     "updated_at": "2024-10-09T13:56:43.000000Z",
        //     "stripe_price_id": "price_1Q80NbAOsdg7Yseiz1Xr31Ih",
        //     "stripe_product_id": "prod_QcYReMD3ioDigD",
        //     "position": null,
        //     "cover_image_uri": "https://www.thestablegame.com/images/531a3308-8f7d-414e-aa2c-2390e50ab004.webp",
        //     "cover_image": {
        //         "imageUUID": "0adb6c14-6797-43d6-91a0-9e431bd8747c",
        //         "uri": "https://www.thestablegame.com/images/531a3308-8f7d-414e-aa2c-2390e50ab004.webp",
        //         "created_at": "2024-10-09T12:37:00.000000Z",
        //         "updated_at": "2024-10-09T12:37:00.000000Z",
        //         "locationUUID": null
        //     }
        // },
        // {
        //     "tourUUID": "15c9c393-4d14-499f-9cb4-d02168ada03f",
        //     "name": "Room 3",
        //     "description": "Enjoy with your family the Beach.",
        //     "priceMin": "30.00",
        //     "priceMax": null,
        //     "duration": 60,
        //     "cover": "068ecd1e-1300-4b3e-824c-e13f40bb10b7",
        //     "createdBy": "0806f694-cf85-4cfc-a9cd-1859552b7fe8",
        //     "created_at": "2024-07-25T12:39:37.000000Z",
        //     "updated_at": "2024-10-09T14:05:17.000000Z",
        //     "stripe_price_id": "price_1Q80VsAOsdg7YseiF0pPZ2xP",
        //     "stripe_product_id": "prod_QcYQzH4UHieBiM",
        //     "position": null,
        //     "cover_image_uri": "https://www.thestablegame.com/images/e4f31c34-0720-414f-a77a-037558a719ec.webp",
        //     "cover_image": {
        //         "imageUUID": "068ecd1e-1300-4b3e-824c-e13f40bb10b7",
        //         "uri": "https://www.thestablegame.com/images/e4f31c34-0720-414f-a77a-037558a719ec.webp",
        //         "created_at": "2024-10-09T12:54:22.000000Z",
        //         "updated_at": "2024-10-09T12:54:22.000000Z",
        //         "locationUUID": null
        //     }
        // },
        // {
        //     "tourUUID": "0410f6e7-ac1d-457d-8cfe-313c32be88b7",
        //     "name": "Room 5",
        //     "description": "Santa!",
        //     "priceMin": "0.00",
        //     "priceMax": null,
        //     "duration": 60,
        //     "cover": "fbfb7734-9174-45b5-9cff-1727b95b8287",
        //     "createdBy": "55f824a7-3f94-4262-b2c9-dea9691a6a0d",
        //     "created_at": "2024-07-25T12:39:37.000000Z",
        //     "updated_at": "2024-10-09T13:23:15.000000Z",
        //     "stripe_price_id": "price_1Q7zrDAOsdg7YseiUOn2DsHW",
        //     "stripe_product_id": "prod_QcYL4Lsysvm26I",
        //     "position": null,
        //     "cover_image_uri": "https://www.thestablegame.com/images/1f9a7fee-b811-43e7-b9b6-223547b04173.webp",
        //     "cover_image": {
        //         "imageUUID": "fbfb7734-9174-45b5-9cff-1727b95b8287",
        //         "uri": "https://www.thestablegame.com/images/1f9a7fee-b811-43e7-b9b6-223547b04173.webp",
        //         "created_at": "2024-10-09T12:56:30.000000Z",
        //         "updated_at": "2024-10-09T12:56:30.000000Z",
        //         "locationUUID": null
        //     }
        // },
        ///////////////////////////////////////////////////////////////
        {
            "tourUUID": "e3b2ba66-ace3-44e3-88d9-cf2046f62bf8",
            "name": "Coach Room",
            "room": "Coach",
            "description": "Gwraar!",
            "priceMin": "10.00",
            "priceMax": null,
            "duration": 180,
            "cover": "e87ea88b-c199-4de3-8fa4-c327e79598fc",
            "createdBy": "55f824a7-3f94-4262-b2c9-dea9691a6a0d",
            "created_at": "2024-07-25T12:39:37.000000Z",
            "updated_at": "2024-10-09T13:20:46.000000Z",
            "stripe_price_id": "price_1Q7zooAOsdg7Ysei0X2b8Ghc",
            "stripe_product_id": "prod_QcYMJRnRWuqkhX",
            "position": null,
            "cover_image_uri": "https://www.thestablegame.com/hotel/Coach.webp",
            "cover_image": {
                "imageUUID": "e87ea88b-c199-4de3-8fa4-c327e79598fc",
                "uri": "https://www.stormlightseekers.xyz/images/f527d6af-0199-4d44-a059-35e41947f7f6.webp",
                "created_at": "2024-09-23T22:11:20.000000Z",
                "updated_at": "2024-09-23T22:11:20.000000Z",
                "locationUUID": null
            }
        },
        {
            "tourUUID": "8a125cff-a5d7-4c74-9fa7-40b2b21979a4",
            "name": "Deluxe Room",
            "room": "Deluxe",
            "description": "The best wildest!",
            "priceMin": "259.00",
            "priceMax": null,
            "duration": 90,
            "cover": "58221964-8955-4a09-8702-470cfd934923",
            "createdBy": "55f824a7-3f94-4262-b2c9-dea9691a6a0d",
            "created_at": "2024-07-25T12:39:37.000000Z",
            "updated_at": "2024-10-09T13:23:35.000000Z",
            "stripe_price_id": "price_1Q7zrWAOsdg7YseiyHpJE39z",
            "stripe_product_id": "prod_QcXvnRMbw9jtYK",
            "position": null,
            "cover_image_uri": "https://www.thestablegame.com/hotel/Deluxe.webp",
            "cover_image": {
                "imageUUID": "58221964-8955-4a09-8702-470cfd934923",
                "uri": "https://www.thestablegame.com/images/c1a11531-8f2f-4db3-bb00-bc2ca4d2fdf1.webp",
                "created_at": "2024-10-09T13:03:21.000000Z",
                "updated_at": "2024-10-09T13:03:21.000000Z",
                "locationUUID": null
            }
        },
        {
            "tourUUID": "bcaee986-d32b-47ab-b17d-6c40929818d9",
            "name": "Business Room",
            "room": "Business",
            "description": "Discover greater peaks!",
            "priceMin": "149.00",
            "priceMax": null,
            "duration": 120,
            "cover": "48a4e087-ae05-4785-8546-80e1b2b5be92",
            "createdBy": "55f824a7-3f94-4262-b2c9-dea9691a6a0d",
            "created_at": "2024-07-25T12:39:37.000000Z",
            "updated_at": "2024-10-09T13:24:11.000000Z",
            "stripe_price_id": "price_1Q7zs7AOsdg7Yseij9NAUvQy",
            "stripe_product_id": "prod_QcYJEKpEdeEWhu",
            "position": null,
            "cover_image_uri": "https://www.thestablegame.com/hotel/Business.webp",
            "cover_image": {
                "imageUUID": "48a4e087-ae05-4785-8546-80e1b2b5be92",
                "uri": "https://www.thestablegame.com/images/c7c11136-8c16-4ac7-be79-dce73e0ecd1f.webp",
                "created_at": "2024-10-09T13:05:45.000000Z",
                "updated_at": "2024-10-09T13:05:45.000000Z",
                "locationUUID": null
            }
        }
    ];

    useEffect(() => {
        // Transform the rooms data to match the tours structure
        const transformedTours = rooms.map(room => ({
            id: room.tourUUID,
            title: room.name,
            room: room.room,
            description: room.description,
            images: room.cover_image_uri,
            price: room.priceMin,
            sprice: room.stripe_price_id,
            priceShown: `${room.priceMin} per Tuktuk`,
            duration: room.duration
        }));
        setTours(transformedTours);
        setLoading(false); // Data is now loaded
        scrollToTop();
    }, []);

    const [imageLoaded, setImageLoaded] = useState(false);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    return (
        <div className="bodySelectTourList">
            {loading ? (
                <div className='spinnerList'>
                    <PSpinner />
                </div>
            ) : (
                <>
                    {!imageLoaded && <SkeletonTourListPreload />}
                    <GridContainer isPhone={isPhone}>
                        {Array.isArray(tours) && tours.length > 0 ? (
                            tours.map((tour, index) => (
                                <BentoCard
                                    key={tour.id}
                                    tourState={tour}
                                    index={index}
                                    {...tour}
                                    onImagesLoad={handleImageLoad}
                                    imageLoaded={imageLoaded}
                                />
                            ))
                        ) : (
                            <p>No tours available.</p>
                        )}
                    </GridContainer>
                </>
            )}
        </div>
    );
}

export default TourList;